import { Tiers } from "./tiers.model";
import { TypeCustomer } from "./type-customers.model";
import { Locality } from "./localities.model";

export class Customer extends Tiers {
  typeCustomer: TypeCustomer;
  code: string;

  raisonSociale?: string;
  ice?: string;
  website?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;

  prospect?: boolean;
  active?: boolean;

  constructor() {
    super();
    this.typeCustomer = new TypeCustomer();
  }
}

export class CustomerForm {
  id: number;
  name: string;
  cin: string;
  phone1: string;
  phone2: string;
  fax: string;
  email: string;
  rib: string;
  patent: string;
  createAt: Date;
  typeCustomer: number;
  code: string;
  locality: Locality;
  commercials: number[];

  raisonSociale?: string;
  ice?: string;
  website?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;

  prospect?: boolean;
  active?: boolean;

  constructor() {
    this.commercials = [];
    this.locality = new Locality();
  }
}
